module.exports = __webpack_public_path__ + "img/icon78.de8e216d.png";